import { useTranslation } from "react-i18next";

import { Modal } from "components";

import { ScriptEndType, ScriptModule } from "./callScripts.types";
import CallScriptsApp from "./CallScriptsApp";

interface CallScriptsModalProps {
  agentName: string;
  clientName: string;
  onClose: () => void;
  onScriptCompleted?: (moduleId: ScriptModule["id"], endType: ScriptEndType) => void;
  opened: boolean;
}

const CallScriptsModal = ({
  agentName,
  clientName,
  onClose,
  onScriptCompleted,
  opened,
}: CallScriptsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} opened={opened} size="lg" title={t("callScripts.title")}>
      <CallScriptsApp
        agentName={agentName}
        clientName={clientName}
        onScriptCompleted={onScriptCompleted}
      />
    </Modal>
  );
};

export default CallScriptsModal;
